import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import {
  Checkbox,
} from 'antd';
import {
  CheckOutlined, CloseOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';

/**
 *
 */
const SyncSetup = ({
  user, getShopifyConnections, shopifyConnections, connectTenantToShopifyLocation, connectTenantToShopifyLocationLoading, setStep, getShopifyConnectionsLoading, history,
}) => {
  useEffect(() => {
    getShopifyConnections(user?.tenant_info?.org_id);
  }, []);

  const shopName = shopifyConnections?.find((connection) => connection?.is_connected)?.shop_name;

  const tenantIntegrations = shopifyConnections?.find((connection) => connection?.is_connected)?.tenant_integrations;

  const oldConfiguration = shopifyConnections?.find((connection) => connection?.is_connected)?.configuration;

  const isInitiallySynced = shopifyConnections?.find((connection) => connection?.is_connected)?.initial_sync;

  const handleSubmit = () => {
    const payload = {
      org_id: user?.tenant_info?.org_id,
      shop_name: shopName,
      initial_sync: !isInitiallySynced,
      update_configuration: true,
    };

    const configuration = {
      ...oldConfiguration,
    };

    payload.tenant_integrations = tenantIntegrations;
    payload.configuration = configuration;

    connectTenantToShopifyLocation(payload, () => {
      history.push('/admin/integration/shopify');
    });
  };

  return (
    <Fragment>
      { getShopifyConnectionsLoading
        ? (
          <div className="shopify-integration__loader__wrapper">

            { [...Array(5).keys()].map((item) => (
              <div key={item} className="shopify-integration__loader-row">
                <div className="loadingBlock  shopify-integration__loader__line1" />
                <div className="loadingBlock  shopify-integration__loader__line2" />
                <div className="loadingBlock  shopify-integration__loader__line3" />
              </div>
            ))}
            <div className="loadingBlock shopify-integration__loader__line-btn1" />
            <div className="loadingBlock shopify-integration__loader__line-btn2" />
          </div>
        )
        : (
          <div className="shopify__sucess-wrapper">

            <div className="shopify__sucess-header-wrapper">
              <div className="shopify__sucess-header">
                Summary
              </div>
              <div className="shopify__sucess-header-info">
                We can automatically synchronize order changes, fulfillment states and inventory levels between Procuzy and Shopify in real time. Please choose your preferences below.
              </div>
            </div>

            <div className="shopify__import-entity">
              <div className="shopify__import-entity-info">You chose to import the following data from Shopify at Initial connect:</div>
              <div className="shopify__import-check">
                <Fragment>
                  {oldConfiguration?.sync_products ? (
                    <div className="verify-tick">
                      <CheckOutlined />
                    </div>
                  )
                    : (
                      <div className="verify-cross">
                        <CloseOutlined />
                      </div>
                    )}
                  <H3Text
                    text="Import all Products."
                    className="workflow__table-body-step-line-text-ok"
                  />
                </Fragment>
              </div>
              {/* <div className="shopify__import-check"> */}
              {/*  <Fragment> */}
              {/*    {oldConfiguration?.sync_customers ? ( */}
              {/*      <div className="verify-tick"> */}
              {/*        <CheckOutlined /> */}
              {/*      </div> */}
              {/*    ) */}
              {/*      : ( */}
              {/*        <div className="verify-cross"> */}
              {/*          <CloseOutlined /> */}
              {/*        </div> */}
              {/*      )} */}
              {/*    <H3Text */}
              {/*      text="Import all Customers." */}
              {/*      className="workflow__table-body-step-line-text-ok" */}
              {/*    /> */}
              {/*  </Fragment> */}
              {/* </div> */}
              {/* <div className="shopify__import-check"> */}
              {/*  <Fragment> */}
              {/*    {oldConfiguration?.sync_orders ? ( */}
              {/*      <div className="verify-tick"> */}
              {/*        <CheckOutlined /> */}
              {/*      </div> */}
              {/*    ) */}
              {/*      : ( */}
              {/*        <div className="verify-cross"> */}
              {/*          <CloseOutlined /> */}
              {/*        </div> */}
              {/*      )} */}
              {/*    <H3Text */}
              {/*      text="Import historical orders. */}
              {/*      ." */}
              {/*      className="workflow__table-body-step-line-text-ok" */}
              {/*    /> */}
              {/*  </Fragment> */}
              {/* </div> */}
              {/* <div className="shopify__import-check"> */}
              {/*  <Fragment> */}
              {/*    {oldConfiguration?.sync_fulfillment ? ( */}
              {/*      <div className="verify-tick"> */}
              {/*        <CheckOutlined /> */}
              {/*      </div> */}
              {/*    ) */}
              {/*      : ( */}
              {/*        <div className="verify-cross"> */}
              {/*          <CloseOutlined /> */}
              {/*        </div> */}
              {/*      )} */}
              {/*    <H3Text */}
              {/*      text="Import order Fulfillment as Invoice on Procuzy." */}
              {/*      className="workflow__table-body-step-line-text-ok" */}
              {/*    /> */}
              {/*  </Fragment> */}
              {/* </div> */}
              {/* <div className="shopify__import-check">
                <Fragment>
                  {oldConfiguration?.sync_refunds ? (
                    <div className="verify-tick">
                      <CheckOutlined />
                    </div>
                  )
                    : (
                      <div className="verify-cross">
                        <CloseOutlined />
                      </div>
                    )}
                  <H3Text
                    text="Import Refunds as Credit Notes on Procuzy."
                    className="workflow__table-body-step-line-text-ok"
                  />
                </Fragment>
              </div> */}
              <div className="shopify__import-check">
                <Fragment>
                  <div className="verify-tick">
                    <CheckOutlined />
                  </div>
                  <H3Text
                    text="Customer will be created during order sync if not existed in procuzy."
                    className="workflow__table-body-step-line-text-ok"
                  />
                </Fragment>
              </div>
              <div className="shopify__import-check">
                <Fragment>
                  {oldConfiguration?.create_custom_item ? (
                    <div className="verify-tick">
                      <CheckOutlined />
                    </div>
                  )
                    : (
                      <div className="verify-cross">
                        <CloseOutlined />
                      </div>
                    )}
                  <H3Text
                    text="Custom items as new product on Shopify."
                    className="workflow__table-body-step-line-text-ok"
                  />
                </Fragment>
              </div>
            </div>

            <div className="shopify__import-entity">
              <div className="shopify__import-entity-info">You chose to sync the following data between Procuzy and Shopify going forward in real time:</div>
              <div className="shopify__import-check">
                <Fragment>
                  {oldConfiguration?.product_webhook ? (
                    <div className="verify-tick">
                      <CheckOutlined />
                    </div>
                  )
                    : (
                      <div className="verify-cross">
                        <CloseOutlined />
                      </div>
                    )}
                  <H3Text
                    text="Synchronize product changes from Shopify to Procuzy."
                    className="workflow__table-body-step-line-text-ok"
                  />
                </Fragment>
              </div>
              <div className="shopify__import-check">
                <Fragment>
                  {oldConfiguration?.order_webhook ? (
                    <div className="verify-tick">
                      <CheckOutlined />
                    </div>
                  )
                    : (
                      <div className="verify-cross">
                        <CloseOutlined />
                      </div>
                    )}
                  <H3Text
                    text="Synchronize order changes from Shopify to Procuzy."
                    className="workflow__table-body-step-line-text-ok"
                  />
                </Fragment>
              </div>
              <div className="shopify__import-check">
                <Fragment>
                  {oldConfiguration?.fulfillment_webhook ? (
                    <div className="verify-tick">
                      <CheckOutlined />
                    </div>
                  )
                    : (
                      <div className="verify-cross">
                        <CloseOutlined />
                      </div>
                    )}
                  <H3Text
                    text="Synchronize fulfillment state between Shopify and Procuzy."
                    className="workflow__table-body-step-line-text-ok"
                  />
                </Fragment>
              </div>
              <div className="shopify__import-check">
                <Fragment>
                  {oldConfiguration?.inventory_webhook ? (
                    <div className="verify-tick">
                      <CheckOutlined />
                    </div>
                  )
                    : (
                      <div className="verify-cross">
                        <CloseOutlined />
                      </div>
                    )}
                  <H3Text
                    text="Synchronize stock levels from Procuzy to Shopify."
                    className="workflow__table-body-step-line-text-ok"
                  />
                </Fragment>
              </div>
            </div>

            <div className="ant-row">
            &nbsp;&nbsp;
              <H3Button
                text="Back"
                buttonType={defaultButtonTypes.BLUE_BORDERED}
                onClick={() => setStep(3)}
                customClass="shopify__sucess-submit"
                disabled={connectTenantToShopifyLocationLoading}
              />
              &nbsp;&nbsp;
              <H3Button
                text="Confirm"
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                onClick={() => handleSubmit()}
                customClass="shopify__sucess-submit"
                isLoading={connectTenantToShopifyLocationLoading}
                disabled={connectTenantToShopifyLocationLoading}
              />
            </div>
          </div>
        )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, ShopifyIntegrationReducers }) => ({
  user: UserReducers.user,
  shopifyConnections: ShopifyIntegrationReducers.shopifyConnections,
  connectTenantToShopifyLocationLoading: ShopifyIntegrationReducers.connectTenantToShopifyLocationLoading,
});
const mapDispatchToProps = (dispatch) => ({
  getShopifyConnections: (orgId, callback) => dispatch(ShopifyIntegrationActions.getShopifyConnections(orgId, callback)),
  connectTenantToShopifyLocation: (payload, callback) => dispatch(ShopifyIntegrationActions.connectTenantToShopifyLocation(payload, callback)),
});

SyncSetup.propTypes = {
  user: PropTypes.any,
  getShopifyConnectionsLoading: PropTypes.bool,
  getShopifyConnections: PropTypes.func,
  connectTenantToShopifyLocation: PropTypes.func,
  connectTenantToShopifyLocationLoading: PropTypes.bool,
  shopifyConnections: PropTypes.any,
  setStep: PropTypes.func,
  history: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SyncSetup));
